const logAssistantFailure = (error) => {
  if (window?.DD_RUM) {
    window.DD_RUM.addError(error, {
      scope: "mfe-container",
      team: "cd.ghostriders",
      component: "Assistant"
    });
  }
};

export default logAssistantFailure;
